import {
    FETCH_BET_TEMPLATE,
    LIST_BET_TEMPLATE,
    MODIFY_BET_TEMPLATE,
    CLEAR_BET_TEMPLATE
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    data: {}
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_BET_TEMPLATE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_BET_TEMPLATE:
            return {
                ...state,
                isLoading: false,
                data: payload
            };
        case MODIFY_BET_TEMPLATE:
            return {
                ...state,
                isLoading: true
            };
        case CLEAR_BET_TEMPLATE:
            return {
                ...state,
                data: {},
                isLoading: false
            };
        default:
            return state;
    }
}